import { useExportFormEntryToPdfMutation } from "../../../services/api/formsApi";
import { useCallback } from "react";
import { useDisplayToast } from "ui/hooks/useDisplayToast";
import { SubmittedFormModel } from "../../../services/api/types/forms/models/SubmittedFormModel";
import { kebabCase } from "lodash";

interface Props {
  entry: SubmittedFormModel;
}

export function useExportFormEntry({ entry }: Props) {
  const { showNewToast, showErrorToast } = useDisplayToast();

  const [exportFormEntry, { isLoading: isExportLoading }] =
    useExportFormEntryToPdfMutation();

  const exportToPdf = useCallback(async () => {
    try {
      const blob = await exportFormEntry({
        entryId: entry.id,
      }).unwrap();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      link.setAttribute(
        "download",
        `${kebabCase(entry.form.name)}-${entry.id}.pdf`,
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      showNewToast({
        title: "Export complete",
        message: `The ${entry.form.name} has been exported successfully`,
        type: "success",
      });
    } catch (error) {
      showErrorToast(error);
    }
  }, [exportFormEntry, entry.id, showNewToast, showErrorToast]);

  return {
    exportToPdf,
    isExporting: isExportLoading,
  };
}
